/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const generateDataSchema = z.object({
  id: z.number(),
  version: z.number(),
  status: z.enum(['generating', 'ready', 'failed']),
});

export interface IGenerateSocialVideoV1Data {
  id: number;
  version: number;
  status: 'generating' | 'ready' | 'failed';
}

export const generateSocialVideoV1ResponseSchema = createApiResponseSchema(
  generateDataSchema,
) as z.ZodSchema<IAPI<IGenerateSocialVideoV1Data>>;

export type IGenerateSocialVideoV1Response = IAPI<IGenerateSocialVideoV1Data>;
